module.exports = new __parcel__URL__("shop_machines_neon_gold_accelerator.0775b29d.png").toString();